export default class Intro {
    constructor() {
        !MAIN.isVisit && this._init();
    }

    _init() {
        // イントロのアニメーションを開始
        this._startIntro();
    }

    _startIntro() {
        const $intro = document.getElementById("intro");
        const $txt = $intro.querySelector(".intro__txt");
        console.log($txt);

        $txt.textContent = $txt.innerHTML.replace(/<br\s*\/?>/g, "\n");

        // 文字列を一文字ずつ span タグで囲む
        this._wrapCharSpan($txt);

        $intro.classList.add("-start");

        // 最後の文字のアニメーション終了後にイントロを閉じる
        $txt.lastChild.addEventListener("animationend", () => this._endIntro($intro));
    }

    _wrapCharSpan($txt) {
        const charArr = [...$txt.textContent.replace(/ +/g, "")];

        $txt.innerHTML = charArr
            .map((char, i) => {
                const delay = i * 0.05 + 2,
                    tag = `<span style="animation-delay: ${delay}s;">${char}</span>`;
                return char === "\n" ? "<br>" : tag;
            })
            .join("");
    }

    _endIntro($intro) {
        const date = new Date();
        date.setHours(23, 59, 59);

        $intro.classList.add("-end");
        MAIN.bg.setActive();

        // イントロを閉じたら背景・メインビジュアルのアニメーションを開始
        $intro.addEventListener("transitionend", () => {
            MAIN.mv.pcAnimation.setLogo(1000);
            MAIN.mv.spAnimation.setLogo(1000);
            MAIN.mv.pcAnimation.setPos(1000);
            MAIN.mv.spAnimation.setPos(1000);
            MAIN.isVisit = true;
            MAIN.cookie.set("phrase_visit", true, { expires: date });
        });
    }
}
